import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight, Sparkles, Shield, Clock } from 'lucide-react';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="relative pt-28 pb-16 px-6 bg-gradient-to-br from-white via-gray-50 to-blue-50 overflow-hidden" aria-label="Hero section">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-100 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-float"></div>
        <div className="absolute top-40 right-10 w-96 h-96 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute bottom-20 left-1/3 w-80 h-80 bg-blue-50 rounded-full mix-blend-multiply filter blur-xl opacity-30 animate-float" style={{animationDelay: '2s'}}></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-10">
          <div className="inline-block mb-6 animate-fade-in-up opacity-0" style={{animationDelay: '0.2s'}}>
            <span className="text-[#003366] font-bold text-xs sm:text-base md:text-lg tracking-wide uppercase border-2 border-[#003366] px-4 sm:px-6 py-2 rounded-full shine-effect hover:shadow-lg transition-all duration-300 hover:scale-105 whitespace-nowrap">
              <Sparkles className="inline-block mr-1 sm:mr-2 mb-1" size={16} aria-hidden="true" />
              Servicing BRITISH COLUMBIA Labour Market
            </span>
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#003366] mb-6 leading-tight animate-fade-in-up opacity-0" style={{animationDelay: '0.4s'}}>
            <span className="gradient-text">WorkNation</span> Labour Ltd
          </h1>
          <p className="text-base md:text-lg text-gray-700 max-w-3xl mx-auto mb-4 leading-relaxed animate-fade-in-up opacity-0" style={{animationDelay: '0.6s'}}>
            Need reliable workers fast? WorkNation Labour Ltd is a staffing agency based in Vancouver, BC that provides <strong>construction, warehouse, food processing, agriculture, transportation, and cold storage</strong> workers across British Columbia. Over <strong>200 workers placed</strong>. No hidden fees. No long-term commitments.
          </p>

          {/* Trust Indicators */}
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-8 animate-fade-in-up opacity-0" style={{animationDelay: '0.7s'}}>
            <span className="flex items-center text-sm text-gray-600">
              <Shield className="text-green-500 mr-1.5" size={16} aria-hidden="true" /> WCB Compliant
            </span>
            <span className="flex items-center text-sm text-gray-600">
              <Clock className="text-blue-500 mr-1.5" size={16} aria-hidden="true" /> 24-48h Placement
            </span>
            <span className="flex items-center text-sm text-gray-600">
              <Sparkles className="text-amber-500 mr-1.5" size={16} aria-hidden="true" /> 200+ Workers Placed
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-10">
          <div className="w-full sm:w-[55%] animate-fade-in-left opacity-0" style={{animationDelay: '0.8s'}}>
            <div className="group bg-[#003366] rounded-lg shadow-xl p-8 border-t-4 border-white transition-all duration-500 hover:shadow-2xl hover:transform hover:scale-105 hover:-translate-y-2 relative overflow-hidden">
              <h2 className="text-2xl font-bold text-white mb-2 relative z-10">Hiring? Get Workers Fast.</h2>
              <p className="text-blue-200 mb-6 relative z-10">Qualified, WCB-compliant workers on-site in 24-48 hours. No hidden fees. No long-term contracts.</p>
              <Button
                onClick={() => navigate('/employers')}
                className="w-full bg-white text-[#003366] hover:bg-gray-100 py-6 text-lg font-semibold transition-all duration-300 group shine-effect relative z-10"
                data-testid="hero-employer-cta"
              >
                Request Workers Now
                <ArrowRight className="ml-2 group-hover:translate-x-2 transition-transform duration-300" size={20} />
              </Button>
            </div>
          </div>

          <div className="w-full sm:w-[45%] animate-fade-in-right opacity-0" style={{animationDelay: '0.8s'}}>
            <div className="group bg-white rounded-lg shadow-lg p-8 border border-gray-200 transition-all duration-500 hover:shadow-xl hover:-translate-y-1 relative overflow-hidden">
              <h2 className="text-xl font-bold text-[#003366] mb-2 relative z-10">Looking for Work?</h2>
              <p className="text-gray-500 mb-6 relative z-10 text-sm">Register and start earning this week</p>
              <Button
                onClick={() => navigate('/job-seekers')}
                className="w-full bg-white border-2 border-[#003366] text-[#003366] hover:bg-[#003366] hover:text-white py-5 text-base font-semibold transition-all duration-300 group relative z-10"
                data-testid="hero-jobseeker-cta"
              >
                Find Work Now
                <ArrowRight className="ml-2 group-hover:translate-x-2 transition-transform duration-300" size={18} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
